import { FaucetProduct, Product, ProductType } from '../';

export function IsFaucetProduct(product: Product): product is FaucetProduct {
  return (product as FaucetProduct).productType === ProductType.FAUCET;
}
